// extracted by mini-css-extract-plugin
module.exports = {"Collapsible":"Collapsible_Collapsible__wSKwc"};